import React, { useState, useContext } from "react";
import {
  Theme
} from "@mui/material/styles";
import { createStyles, makeStyles } from '@mui/styles';
import {
  Button,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem
} from "@mui/material";
import { useLocalStorage } from "../utils/LocalStorageHook";
import { checkForRole, checkForRoles } from "../utils/GetAuth";
import { useHistory } from "react-router-dom";

import {getPublicImagePath} from "../App"

import { IconButton, TextField, Dialog, Stack, DialogContent, DialogTitle } from "@mui/material";

import {
  Description,
  Store,
  PlaylistAddCheck,
  Tune,
  Explore,
  Assessment,
  List,
  Settings,
  AssignmentTurnedIn,
  SportsCricket,
  Kitchen,
  Dashboard,
  Public,
  FormatColorFill,
  ReportOff,
  Inventory,
  SwapHoriz,
  Search,
  Close,
   
} from "@mui/icons-material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import RouteIcon from '@mui/icons-material/Route';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { DisplayRoleContext } from "src/Context_api";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      height: "32px",
      margin: "0px 0px 0px 0px"
    },
    menu: {},
    menuItem: {}
  }));

export default function NavigationDropdown() {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [soSetting, setSoSetting] = useLocalStorage("SETTINGS.salesOrg", "");
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");

  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);

  const [showSearchCustPopUp, setShowSearchCustPopUp] = useState(false);
  const [customerID, setCustomerID] = useState("");
  const [isValidCustomer, setValidCustomer] = useState(true);

  const handleSOClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSOClose = (salesOrg: string) => {
    if (typeof salesOrg === "string" && salesOrg && soSetting !== salesOrg) {
      setSoSetting(salesOrg);
      window.location.reload();
    }
    setAnchorEl(null);
  };



  const navigationMenuItem = (pathname: string, icon: any, title: string, onClickMethod?: any) => {
    return (
      <MenuItem
        className={classes.menuItem}
        key={pathname}
        onClick={() => {
          if (onClickMethod) {
            onClickMethod();
          } else {
            history.push(pathname);
          }
        }}
        //selected={(location?.pathname || "") === pathname}
      >
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        {title}
      </MenuItem>
    )
  }

  //Section to search a customer
  const handleCustomerSearch = (query: string) => {
    window.open(`/customer/${query as any}`, "_blank");
  };

  // function to provide model to serach a customer;
  const searchCustomerModal = (
    <Dialog
      open={showSearchCustPopUp}
      onClose={() => setShowSearchCustPopUp(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          p: 3,
          borderRadius: 2,
          position: "relative",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "1.3rem", fontWeight: "bold"}}>
        Enter Customer Number
        <IconButton onClick={() => setShowSearchCustPopUp(false)} sx={{ position: "absolute", top: 16, right: 16 }}>
          <Close />
        </IconButton>
      </DialogTitle>

      {!isValidCustomer ? <DialogTitle style={{color: "red"}} sx={{ fontSize: "1rem", fontWeight: "bold"}}>
        Invalid customer number, please enter valid customer number.
      </DialogTitle> :<></>}
    
      <DialogContent>
        <Stack direction="row" alignItems="center" marginTop={"5px;"}>
          <TextField
            required
            type="number"
            label="Customer Number"
            variant="outlined"
            value={customerID}
            onChange={(e) => {
              if(e.target.value.length > 10){
                  e.preventDefault();
                  return;
              }
              setCustomerID(e.target.value);
            }}
            InputProps={{
              inputProps: {
                maxLength: 10,
                pattern: '[0-9]*'
              },
            }}
            fullWidth
          />
          <Button
            variant="contained"
            sx={{ height: "56px", minWidth: "100px", marginLeft:"15px" }}
            onClick={() => {
              setValidCustomer(true);
              if (!customerID.trim() || customerID.length < 9) {
                setValidCustomer(false)
                return;
              }
              
              let prefixedCustNumber = customerID;
              if(customerID.length === 9){
                prefixedCustNumber = (`0${prefixedCustNumber}`);
              }
              handleCustomerSearch(prefixedCustNumber);
            }}
          >
            Search
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );


  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleSOClick}
        color="inherit"
        variant="text"
        style={{marginRight:"20px"}}
      >
        <img
          className={classes.logo}
          src={getPublicImagePath("./cona_services_logo_transparent_white.png")}
          alt="CONA"
        ></img>
        <img
          className={classes.logo}
          src={getPublicImagePath("./NextGenVending.png")}
          alt="CONA"
        ></img>
      </Button>
      <Menu
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleSOClose}
      >
        {checkForRoles(clientId, salesOrg, ["vp_access", "vs_access"]) ? (
          <div>
            {navigationMenuItem('/customers',<Store />,'Customers')}
             {navigationMenuItem("", <Search />, "Search Customer", () => setShowSearchCustPopUp(true))}
            {navigationMenuItem('/telemeter_dashboard',<MonitorHeartIcon />,'Telemeter Dashboard')}
            <Divider />
          </div>
        ) : (
          <div></div>
        )}
        
        {checkForRole(clientId, salesOrg, "vs_access") ? (
          <div>
            {navigationMenuItem('/vendsmart/planning',<Explore />,'Route Planning')}
            {!isDisplayOnlyRole ? navigationMenuItem('/vendsmart/adjustclosinginventory',<Inventory />,'Adjust Closing Inventory'):<></>}
            <Divider />
          </div>
        ) : (
          <div></div>
        )}
        {checkForRole(clientId, salesOrg, "vp_access") ? (
          <div>
            {navigationMenuItem('/vendprime/queue',<PlaylistAddCheck />,'Pending Queue')}
            {navigationMenuItem('/vendprime/monitor',<List />,'Request Monitor')}
            {navigationMenuItem('/vendprime/notes',<Description />,'Reconfig Notes')}
            {navigationMenuItem('/bottlermap',<Public />,'Bottler Map')}
            {navigationMenuItem('/materialswap',<SwapHoriz />,'Material Swap')}
            <Divider />
          </div>
        ) : (
          <div></div>
        )}
        {checkForRoles(clientId, salesOrg, ["vp_access", "vs_access"]) ? (
          <div>
            {!isDisplayOnlyRole ? navigationMenuItem('/routemanagement',<RouteIcon />,'Route Management'):<></>}
            {navigationMenuItem('/reporting/configuration',<Assessment />,'Configuration Report')}
            {navigationMenuItem('/reporting/utilization',<Kitchen />,'Utilization Report')}
            {navigationMenuItem('/reporting/planning',<AssignmentTurnedIn />,'Planning Report')}
            {navigationMenuItem('/reporting/vmdex',<SportsCricket />,'VM-DEX Report')}
            {navigationMenuItem('/reporting/vmmattype',<Dashboard />,'VM-Material Report')}
            {navigationMenuItem('/reporting/fillrate',<FormatColorFill />,'Average Fill Rate Report')}
            {navigationMenuItem('/reporting/missedstop',<ReportOff />,'Missed Stops Report')}
            {navigationMenuItem('/reporting/missedstop',<ReportOff />,'Missed Stops Report')}
            <Divider />
          </div>
        ) : (
          <div></div>
        )}
        {checkForRoles(clientId, salesOrg, ["vp_access", "vs_access"]) ? (
          <div>
            {navigationMenuItem('/remotepricemanagement',<AttachMoneyIcon />,'Remote Price Management')}
            <Divider />
            </div>
        ):(<div></div>)}
        {checkForRoles(clientId, salesOrg, ["security_admin","batch_monitor","vp_admin","vs_admin","vp_admin_bulk","vs_admin_bulk"]) ? (
          <div>
            {navigationMenuItem('/admin',<Tune />,'Admin')}
            <Divider />
          </div>
        ) : (
          <div></div>
        )}
        {navigationMenuItem('/settings',<Settings />,'User Settings')}
      </Menu>
      {searchCustomerModal}
    </div>
  );
}
